module.exports = __webpack_public_path__ + "static/media/ride.b0d70ec5.wav";